import {
  BUZZ_CAROUSEL_SCROLL_INTERVAL,
  BUZZ_CAROUSEL_OFFSET,
  BUZZ_CAROUSEL_IMAGE_LIST_CLASS_NAME,
} from "./article.constants";

export const getShareUrl = (categorySlug, postSlug) => {
  return `${
    process.env.GATSBY_SITE_URL ||
    "https://share.market/buzz"
  }/${categorySlug}/${postSlug}`;
};

// Article carousel
export const canCarouselNavigateFwd = carouselDiv =>
  Math.floor(
    carouselDiv.scrollWidth - carouselDiv.clientWidth
  ) === Math.floor(carouselDiv.scrollLeft);

export const canCarouselNavigateBack = carouselDiv =>
  Math.floor(carouselDiv.scrollLeft) === 0;

export const enableCarouselNavigation = navBtn => {
  if (navBtn?.classList?.contains("disabled")) {
    navBtn?.classList?.remove("disabled");
    navBtn.disabled = false;
  }
};

export const disableCarouselNavigation = navBtn => {
  navBtn?.classList?.add("disabled");
  navBtn.disabled = true;
};

export const handleCarouselDivScroll = (
  carouselDiv,
  navFwd,
  navBack
) => {
  if (canCarouselNavigateFwd(carouselDiv)) {
    enableCarouselNavigation(navFwd);
    disableCarouselNavigation(navBack);
  } else if (canCarouselNavigateBack(carouselDiv)) {
    enableCarouselNavigation(navBack);
    disableCarouselNavigation(navFwd);
  } else {
    enableCarouselNavigation(navFwd);
    enableCarouselNavigation(navBack);
  }
};

export const carouselNavigation = (
  carouselDiv,
  navButton,
  moveFwd
) => {
  const leftNav = moveFwd
    ? BUZZ_CAROUSEL_SCROLL_INTERVAL
    : -BUZZ_CAROUSEL_SCROLL_INTERVAL;
  carouselDiv.scroll({
    left: carouselDiv.scrollLeft + leftNav,
  });
  if (canCarouselNavigateFwd(carouselDiv)) {
    disableCarouselNavigation(navButton);
  }
};

export const getFullWidthWithLeftMargin = contentRightWidth =>
  `calc(100% + ${
    window.innerWidth - contentRightWidth
  }px - ${BUZZ_CAROUSEL_OFFSET})`;

export const setupArticleImgCarousels = (
  carouselDivs,
  contentRightWidth
) => {
  for (let i = 0; i < carouselDivs.length; i++) {
    const galleryDiv = carouselDivs[i];
    galleryDiv.style.width = getFullWidthWithLeftMargin(
      contentRightWidth
    );
    const noOfImages = carouselDivs[
      i
    ].getElementsByClassName(
      BUZZ_CAROUSEL_IMAGE_LIST_CLASS_NAME
    )[0].children.length;
    if (noOfImages > 2) {
      const galleryImgList = galleryDiv.getElementsByClassName(
        BUZZ_CAROUSEL_IMAGE_LIST_CLASS_NAME
      )[0];
      const galleryDivBack = galleryDiv.querySelector(
        ".navigation .back"
      );
      const galleryDivFwd = galleryDiv.querySelector(
        ".navigation .forward"
      );
      galleryImgList.onscroll = () => {
        handleCarouselDivScroll(
          galleryImgList,
          galleryDivBack,
          galleryDivFwd
        );
      };
      disableCarouselNavigation(galleryDivBack);
      galleryDivBack.onclick = () => {
        enableCarouselNavigation(galleryDivFwd);
        carouselNavigation(
          galleryImgList,
          galleryDivBack,
          false
        );
      };
      galleryDivFwd.onclick = () => {
        enableCarouselNavigation(galleryDivBack);
        carouselNavigation(
          galleryImgList,
          galleryDivFwd,
          true
        );
      };
    }
  }
};
